export const appointment = {
  appointmentStatus: [{
    value: 0, label: '有效'}, {
    value: 1, label: ''}, {
    value: -1, label: '删除'
  }]
}

export default {
  appointment
}



// WEBPACK FOOTER //
// ./src/data/appointment.js